import React from "react";
import RadioButtonDefecto from "../../../../../Common/Components/RadioButtonDefecto2";

const FuncionamientoLimites = ({ data, selectRadio }) => {
    const { GET_FUNCIONAMIENTO_LIMITES } = data;

    if(data && data.NuevosAtributos) GET_FUNCIONAMIENTO_LIMITES.map(fl=>{fl.Visible = fl.Id != 1 ; fl.Checked = fl.Id != 1});

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Funcionamiento de L\u00EDmites"}</label>

                {GET_FUNCIONAMIENTO_LIMITES.map(item => {
                    const referencia = `GFL-${item.Id}`;

                    return (
                        <RadioButtonDefecto
                            key={item.Id}
                            nombre={"GFL"}
                            descripcion={item.Descripcion}
                            valor={item.Id}
                            checked={item.Checked}
                            disabled={!item.Visible}
                            referencia={referencia}
                            selectRadio={(valor) => selectRadio("GET_FUNCIONAMIENTO_LIMITES", valor, item.Codigo)} />
                    );
                })}

                {data.ERROR_PRODUCT["seleccionoFuncionamientoLimites"] == false &&
                    <label className="error">{"Debe seleccionar al menos un funcionamiento l\u00EDmite."}</label>}
            </div>
        </div>
    );
}

export default FuncionamientoLimites;